<template>
  <v-card
    :class="{ 'mb-8': true }"
    width="100%"
    :hover="viewMode == 'grid'"
    @dragstart.stop.prevent="dragStart"
    :draggable="viewMode == 'grid'"
    @mouseleave="hovering ? (hovering = false) : null"
    @mouseover.stop="
      !dragSelecting
        ? (hovering = true)
        : dragSelecting
        ? $emit('selectMouseEnter', card)
        : null
    "
  >
    <note-card-drop-helper
      v-if="userCanEdit"
      :item="card"
      :page="page"
      :viewMode="viewMode"
      :preventDrop="preventNoteDrop"
    ></note-card-drop-helper>
    <v-card-text class="">
      <v-row no-gutters>
        <note-card-content
          :id="'block-' + card.id"
          class="note-block"
          ref="content"
          :card="card"
          :slowLoad="slowLoad"
          :hidingChildren="!showChildren"
          :viewMode="viewMode"
          :hovering="hovering"
          @hideChildren="showChildren = false"
          @showChildren="showChildren = true"
          @startDragSelect="startDragSelect($event, card.id)"
          @addNewLine="addNewLine"
          @moveLineBack="moveLineBack"
          @moveNextLineBack="moveNextLineBack"
          @traverseUp="$emit('traverseOut', $event)"
          @traverseDown="
            showChildren
              ? traverseTo({ ...$event, toRef: 'cardDoc' })
              : $emit('traverseOut', $event)
          "
          @moveToLine="moveToLine"
          @dragStart="dragStart"
          @deleteCard="$emit('deleteCard', { cardId: card.id })"
        ></note-card-content>
      </v-row>
    </v-card-text>
    <v-expand-transition>
      <div
        v-show="showChildren && viewMode == 'full'"
        class="white"
        @mouseenter="preventNoteDrop = true"
        @mouseleave="preventNoteDrop = false"
      >
        <v-divider></v-divider>
        <v-card-text class="px-12 ml-2 pt-6">
          <context-doc
            ref="cardDoc"
            :parentDocId="page.id"
            :parentType="'page'"
            :docNotes="noteBlocks"
            :nestedNotes="nestedNotes"
            :allowQuoteAttr="false"
            :selectedNoteBlocks="selectedNoteBlocks"
            @updateSelectedNotes="$emit('updateSelectedNotes', $event)"
            @removeNoteBlock="removeNote({ ...$event, pageId: page.id, cardId: card.id })"
            @addNewLine="addNewLine"
            @pasteNoteBlocks="pasteNoteBlocks"
            @updateNoteBlockHTML="updateNoteHTML({ ...$event, pageId: page.id })"
            @addNoteBlock="
              addCardNote({
                ...$event,
                pageId: page.id,
                cardId: $event.parentNoteId ? false : card.id
              })
            "
            @traverseLeaveUp="$refs.content.focusSummary($event)"
            @traverseLeaveDown="$emit('traverseOut', $event)"
          >
          </context-doc>
          <div
            style="height: 30px; width: 100%; cursor: text; color: rgba(0, 0, 0, 0.4); font-size: 1rem;"
            @click=""
          >
            <template v-if="!noteBlocks.length">
              Add notes and research...
            </template>
          </div>
        </v-card-text>
      </div>
    </v-expand-transition>
  </v-card>
</template>

<script>
import NoteCardContent from './NoteCardContent';
import NoteCardDropHelper from './NoteCardDropHelper';
import ContextDoc from '@/components/ContextDoc';

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  components: { NoteCardContent, NoteCardDropHelper, ContextDoc },
  props: {
    card: {
      type: Object,
      default() {
        return {};
      }
    },
    viewMode: {},
    page: {},
    slowLoad: {},
    selectedNoteBlocks: {}
  },
  data() {
    return {
      dragSelecting: false,
      hiddenNoteBlocks: [],
      closedParents: [],
      showChildren: true,
      preventNoteDrop: false,
      blocks: [],
      hovering: false
    };
  },
  destroyed() {
    document.removeEventListener('keypress', this.copyTrigger);
  },
  computed: {
    ...mapState('views/context', ['selectedPageId', 'focusTo', 'showResourcePanel']),
    ...mapState('pages', ['pages']),
    ...mapState('components/notepad', ['clipboard']),
    ...mapGetters('components/dragdrop', ['dragging']),
    ...mapGetters('context', ['questions', 'userCanEdit']),
    ...mapGetters('pages', ['notesByCard']),
    // blocks() {
    //   return Object.values(this.card.noteBlocks);
    // },
    noteBlocks() {
      return this.notesByCard[this.card.id];
      // console.log('calc note blocks');
      // return Object.values(this.page.pageNotes)
      //   .filter(n => n.cardId == this.card.id && !n.toDelete)
      //   .sort((a, b) => (a.order > b.order ? 1 : -1));
    },
    nestedNotes() {
      return Object.values(this.page.pageNotes).filter(n => n.parentNoteId);
    }
  },
  methods: {
    ...mapActions('pages', ['removeNote', 'addCardNote', 'updateNoteHTML', 'duplicateNotes']),
    ...mapMutations('components/cardDoc', ['setClipboard']),
    ...mapMutations('components/dragdrop', ['setDragPosition', 'updateDraggedData']),
    log(x) {
      console.log(x);
    },
    focusTitle() {
      this.$refs.content.focusTitle({});
    },
    // selectBlockHotKeys(event) {
    //   const key = event.which || event.keyCode;
    //   console.log(event);
    //   if (key == 67 && event.ctrlKey) {
    //     this.copyBlocks();
    //   }
    //   if (key == 46 || key == 8) {
    //     //  handle delete
    //     this.deleteSelectedBlocks();
    //   }
    // },
    pasteNoteBlocks(order) {
      const { contents, parent } = this.clipboard;
      this.duplicateNotes({
        noteIds: contents,
        startingPosition: order,
        fromPageId: parent,
        toPageId: this.page.id,
        toCardId: this.card.id
      });
    },
    // deleteSelectedBlocks() {
    //   const blockIds = this.selectedNoteBlocks;
    //   blockIds.forEach(b => {
    //     this.removeNoteBlock({ noteBlockId: b, pageId: this.selectedPageId });
    //   });
    // },
    startDragSelect(e, noteId) {
      this.dragSelecting = true;
      this.selectedNoteBlocks = [noteId];
      this.$refs.dragSelect.onMouseDown(e);
    },
    // toggleSelection(note) {
    //   //  check if the note we entered is already selected
    //   console.log(note.id);
    //   const selected = this.selectedNoteBlocks.includes(note.id);
    //   if (selected) {
    //     console.log('remove ', note.order);
    //     //  Already selected, we are going back and should deselect the previous one
    //     if (this.selectedNoteBlocks[this.selectedNoteBlocks.length - 1] != note.id) {
    //       this.selectedNoteBlocks.pop();
    //     }
    //   } else {
    //     console.log('add ', note.order);
    //     //  Add this one to selected
    //     this.selectedNoteBlocks.push(note.id);
    //   }
    // },
    // clearDragSelection() {
    //   this.selectedNoteBlocks = [];
    // },
    async addNewLine({ order, delta }) {
      //  update order of all higher up notes
      //  new vuex note here, returns id
      const newId = await this.addCardNote({
        html: '',
        order: order,
        pageId: this.page.id,
        cardId: this.card.id
      });

      this.$nextTick(() => {
        if (delta) {
          this.setNoteContent({ noteId: newId, delta: delta });
        }
        this.focusNoteBlock({ noteId: newId });
      });
    },
    // tab() {
    //   this.setFocusTo('listItem' + this.selectedPageId);
    // },
    focusNoteBlock({ noteId }) {
      this.$refs['cardDoc'].focusNoteBlock({ noteId });
      //this.$refs[noteId][0].$refs.editor.focus();
    },
    setNoteContent({ noteId, delta }) {
      this.$refs['cardDoc'].setNoteContent({ noteId, delta });
    },
    moveToLine({ toIndex, direction }) {
      const to = this.selectedPageNotes.find(n => n.order == toIndex);
      if (to) {
        const toRef = this.$refs[to.id][0];
        const index = direction == 'next' ? 1 : toRef.$refs.editor.editor.getLength();
        toRef.$refs.editor.editor.setSelection(index);
      }
    },
    moveLineBack({ note, delta }) {
      console.log(delta);
      const prev = this.selectedPageNotes.find(n => n.order == note.order - 1);
      const prevRef = this.$refs[prev.id] ? this.$refs[prev.id][0] : false;
      if (prev && prevRef) {
        if (this.$refs[prev.id][0].note.type != 'widget') {
          const contentEditor = this.$refs[prev.id][0].$refs.editor;
          const editor = contentEditor.editor;
          editor.setSelection(editor.getLength());
          if (delta) {
            contentEditor.updateContents(delta);
          }
        } else {
          this.$refs[prev.id][0].$refs.widget.$el.focus();
          if (delta) {
            //  If there is content on this line, just leave it alone
            return;
          }
        }
        //  delete note
        this.removeNoteBlock({ noteBlockId: note.id, pageId: this.selectedPageId });
      } else if (note.type == 'widget') {
        //  widgets we can just delete
        this.removeNoteBlock({ noteBlockId: note.id, pageId: this.selectedPageId });
      }
    },
    moveNextLineBack({ note }) {
      const next = this.selectedPageNotes.find(n => n.order == note.order + 1);
      const nextRef = this.$refs[next.id] ? this.$refs[next.id][0] : false;
      if (next && nextRef) {
        if (this.$refs[next.id][0].note.type != 'widget') {
          const nextDelta = this.$refs[next.id][0].$refs.editor.editor.getContents();
          this.$refs[note.id][0].$refs.editor.updateContents(nextDelta);
          this.removeNoteBlock({ noteBlockId: next.id, pageId: this.selectedPageId });
        } else {
          this.$refs[next.id][0].$refs.widget.$el.focus();
          if (this.$refs[note.id][0].$refs.editor.editor.getLength() == 1) {
            this.removeNoteBlock({ noteBlockId: note.id, pageId: this.selectedPageId });
          }
        }
      }
    },
    traverseTo({ toRef, direction, event }) {
      this.$refs[toRef].traverseInto({ direction, event });
    },
    traverseInto({ direction, event }) {
      if (direction == 'up') {
        //traverse into the last note
        console.log('traverse into card doc');
        if (this.showChildren) {
          this.$refs.cardDoc.traverseInto({ direction, event });
        } else {
          this.$refs.content.focusSummary({ direction, event });
        }
      } else {
        this.$refs.content.focusTitle({ direction, event });
      }
    },
    dragStart(event) {
      const ids = [this.card.id];
      const element = this.$refs.content.$el;
      const shift = {
        x: event.clientX - element.getBoundingClientRect().left,
        y: event.clientY - element.getBoundingClientRect().top
      };
      // get the element and shift positions for dragHelper
      let html = element.innerHTML;
      //  Build the html drag element
      // let allIds = ids;
      // if (this.selectedNoteBlocks && this.selectedNoteBlocks.includes(ids[0])) {
      //   //  Drag all the selected note blocks
      //   allIds = this.selectedNoteBlocks;
      // }
      // allIds.forEach(i => {
      //   html += this.$refs[i][0].$el.innerHTML;
      // });

      // update drag data
      const dragObject = {
        element,
        shift,
        html,
        ids,
        items: [this.card],
        types: ['noteCard'],
        parent: {
          id: this.selectedPageId,
          type: 'page'
        }
      };
      //  first set initial drag position
      const { x, y } = event;
      this.setDragPosition({ x, y });

      //  now set drag content
      this.updateDraggedData(dragObject);
    }
  }
};
</script>

<style>
.v-card .note-block {
  font-size: 1rem;
}
</style>
